import { IoChevronBack } from "react-icons/io5";
import { useNavigate } from "react-router-dom";
import TextTranslate from "../../../utils/TextTranslate";
import CallHistoryTabs from "./CallHistoryTabs";

export default function CallHIstory() {
  const navigate = useNavigate();

  return (
    <div className="relative flex h-[100dvh] w-full flex-col overflow-hidden bg-secondary pb-[calc(3.25rem+env(safe-area-inset-bottom))] shadow-inner lg:max-w-md lg:pb-0">
      <div className="sticky top-0 z-20 shrink-0 border-b border-black/[0.06] bg-secondary/85 backdrop-blur-xl dark:border-white/[0.08]">
        <div className="flex items-center justify-between px-3 py-3">
          <button
            type="button"
            aria-label="Back"
            className="grid h-9 w-9 place-content-center rounded-full bg-black/[0.06] text-darkText transition active:scale-95 dark:bg-white/10 lg:invisible"
            onClick={() => navigate(-1)}
          >
            <IoChevronBack className="text-xl" />
          </button>
          <span className="text-[17px] font-semibold tracking-tight text-darkText">
            <TextTranslate text="Call History" />
          </span>
          <div className="h-9 w-9" aria-hidden />
        </div>
      </div>

      <div className="min-h-0 flex-1 overflow-hidden">
        <CallHistoryTabs />
      </div>
    </div>
  );
}
